import { apiStudent } from '@/lib/api-manager'
import type { StudentSessionType } from '@/types/student/student-session.type'

export const studentSessionValidate = async (refreshToken?: string) => {
  const result = await apiStudent.post('v1/auth/students/session', {
    refreshToken
  })
  return result.data.data as StudentSessionType
}
